export class ContentRequestStates {
    Name: string;
    Description: string;
    OldVideoTaskState: string;
    OldContentRequestState: string;

    name: string;
}